<template>
  <div class="proposal__wrap">
    <div class="fdfdf crumbs__wrap">
      <el-button
        class="backBtn"
        @click="$router.go(-1)"
        plain
        icon="el-icon-d-arrow-left"
        size="mini"
        >返回</el-button
      >
      &nbsp;&nbsp;&nbsp;
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/agent' }"
          >代理管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>交易明细列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="section shadow filter__wrap">
      <div>
        <el-radio-group v-model="table.params.type" @change="handleTabs">
          <el-radio-button :label="1">收益明细</el-radio-button>
          <el-radio-button :label="2">提现明细</el-radio-button>
        </el-radio-group>
      </div>
      <el-form ref="elFormDom" inline :model="table.params">
        <el-form-item label="" prop="divide_type">
          <el-select
            v-model="table.params.divide_type"
            filterable
            clearable
            placeholder="请选择收益类型"
            @change="handleSearch"
          >
            <el-option
              v-for="item in divide"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getTable"
            >查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="table.params.type === 1 ? field : field2"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:divide_type="{ row }">
          {{
            ["", "下载简历", "成功入职", "开通会员" ,"查看简历"][
              row.divide_type
            ]
          }}
        </template>
        <template v-slot:amount="{ row }">
          <span>{{ row.amount }}元</span>
        </template>
        <template v-slot:user_name="{ row }">
          <el-button type="text" @click="showEdit(row)">{{
            row.user_name
          }}</el-button>
        </template>
        <template v-slot:action="{ row }">
          <el-button
            type="text"
            icon="el-icon-delete"
            class="delBtn"
            @click="handleDelete(row)"
            >删除</el-button
          >
        </template>
      </VTable>
    </div>
    <!-- 查看简历 -->
    <edit ref="edit"></edit>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import Edit from "./Edit.vue";
export default {
  name: "SalesmanList",
  mixins: [mixinTable],
  components: {
    VTable,
    Edit,
  },
  data() {
    return {
      field: [
        { name: "amount", label: "收益金额(元)", hidden: false },
        { name: "divide_type", label: "收益类型", hidden: false },
        { name: "user_name", label: "用户名称", hidden: false },
        // { name: "salesman_name", label: "支付宝名称", hidden: false },
        { name: "company_name", label: "公司名称", hidden: false },
        { name: "pay_time", label: "收益时间", hidden: false },
      ],
      field2: [
        { name: "amount", label: "提现金额(元)", hidden: false },
        { name: "divide_type", label: "收益类型", hidden: false },
        { name: "user_name", label: "用户名称", hidden: false },
        { name: "salesman_name", label: "支付宝名称", hidden: false },
        { name: "company_name", label: "支付宝账号", hidden: false },
        { name: "pay_time", label: "到账时间", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          type: 1,
          order_no: "",
          agent_id: sessionStorage.getItem("agentId"),
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      divide: [
        {
          id: 1,
          name: "下载简历",
        },
        {
          id: 2,
          name: "成功入职",
        },
        {
          id: 3,
          name: "开通会员",
        },
        {
          id: 4,
          name: "查看简历",
        },
      ],
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/order/agent", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 删除
    handleDelete(row) {
      this.$confirm("请确认删除操作?", "提示", {
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.$http.post("/admin/agent/del", { id: row.id }).then((res) => {
            if (res.code === 1) {
              this.$message.success("删除成功");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 查看简历
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom.getUserInfo({ id: row.user_id });
      dom = null;
    },
  },
};
</script>

<style scoped lang="scss">
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;
  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }

  .crumbs__wrap {
    margin-bottom: 20px;
  }
}
.fdfdf {
  display: flex;
  align-items: center;
}
</style>